/* Server-side conversion relay + Google Ads Enhanced Conversions (client).
 * - Pushes user-provided data to the dataLayer for GTM Enhanced Conversions.
 * - Sends a de-duplicated server-side event to the backend, which forwards to
 *   Meta CAPI + GA4 Measurement Protocol (both no-op until credentials are set).
 * Only fires when the visitor has granted marketing consent.
 */
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import { hasMarketingConsent } from "./consent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Read the GA4 client id from the _ga cookie (GA1.1.XXXX.YYYY -> XXXX.YYYY).
function getClientId() {
  try {
    const m = document.cookie.match(/_ga=GA\d\.\d\.(\d+\.\d+)/);
    if (m) return m[1];
  } catch (e) {
    /* no-op */
  }
  return undefined;
}

function pushEnhancedConversion(user) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "user_data_ready",
    user_data: {
      email: user.email || undefined,
      phone_number: user.phone || undefined,
      address: {
        first_name: user.first_name || undefined,
        last_name: user.last_name || undefined,
      },
    },
  });
}

/**
 * fireConversion — call at each conversion point.
 * @param {"lead"|"begin_checkout"|"purchase"} event_name
 * @param {object} opts { user:{email,phone,first_name,last_name}, value, currency, transaction_id }
 * @returns {string|undefined} event_id (also usable for browser-pixel dedupe)
 */
export function fireConversion(event_name, opts = {}) {
  if (!hasMarketingConsent()) return undefined;
  const user = opts.user || {};
  pushEnhancedConversion(user);

  const event_id = uuidv4();
  const payload = {
    event_name,
    event_id,
    client_id: getClientId(),
    source_url: typeof window !== "undefined" ? window.location.href : "",
    email: user.email,
    phone: user.phone,
    first_name: user.first_name,
    last_name: user.last_name,
    value: opts.value,
    currency: opts.currency || "AUD",
    transaction_id: opts.transaction_id,
  };
  // Fire-and-forget; never block the UX or throw.
  axios.post(`${API}/conversions`, payload).catch(() => {});
  return event_id;
}
